var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndus6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 43,
    viewBox: "0 0 54 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 11,
    rx: 1.5,
    stroke: "#000064"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 15.5H3V16V35V35.5H3.5H23.5C24.8807 35.5 26 34.3807 26 33V18C26 16.6193 24.8807 15.5 23.5 15.5H3.5Z",
    stroke: "#000064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 42.5H3V11.5H36.5V32.5",
    stroke: "#000064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C29.7386 32.5 27.5 34.7386 27.5 37.5C27.5 40.2614 29.7386 42.5 32.5 42.5H38.5C41.2614 42.5 43.5 40.2614 43.5 37.5C43.5 34.7386 41.2614 32.5 38.5 32.5H32.5Z",
    stroke: "#000064"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.996 26.365L44.9878 23.0608C42.6828 21.5401 39.5815 22.1758 38.0608 24.4808C36.5401 26.7858 37.1758 29.8871 39.4808 31.4078L44.489 34.712C46.794 36.2328 49.8953 35.597 51.416 33.292C52.9368 30.9871 52.301 27.8857 49.996 26.365Z",
    stroke: "#000064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5V11.5",
    stroke: "#000064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5V11.5",
    stroke: "#000064"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.5V11.5",
    stroke: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndus6);
export default __webpack_public_path__ + "static/media/indus6.ddfdde70b6e1ad8b185c38ac9e1a9892.svg";
export { ForwardRef as ReactComponent };